import React, { useState, useEffect, useContext, useLayoutEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ReactSVG } from 'react-svg';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { get } from 'lodash';
import { resetStores } from '@kfc-global/react-shared/redux/Actions/StoresAction';
import {
  getApplicableCouponsAction,
  applyCoupon,
  removeCouponAction,
} from '@kfc-global/react-shared/redux/Actions/CartAction';
import AlertFormInsideModel from 'molecules/Alert';
import AlertForm from 'molecules/Alert/Presentation/Alert/AlertForm';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';
import { UserOrderContext } from 'context/context';
import { ButtonComp } from 'atoms/Buttons';
import {
  getDispositionTypeOnAPIFormat,
  getHeaderContentData,
  getValueOrDefaultObject,
  getValueOrnull,
  toastifyFnWithImage,
  isEmptyObject,
  isMobileDevice,
  getAndCheck,
  isCateringDisposition,
  getTernaryValue,
  getAndCheckIfOneTrue,
  getValueOrEmptyString,
} from 'common/utilities/utils';
import {
  modifyOffersData,
  getFinalContentData,
  isTimeValid,
  truncate,
} from 'organisms/PromosRewards/utils/promosRewardsUtils';
import { login } from 'common/utilities/LoginUtils';
import { getDispositionNewData } from 'organisms/MenusPLP/MenusPlpUtilities/MenuPLPSharedUtils';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';
import TimerView from 'organisms/PromosRewards/Presentation/TimerView';
import PromosRewardsCard from 'organisms/PromosRewards/Presentation/PromosRewardsCard';
import PromosBanner from 'organisms/PromosRewards/Presentation/PromosBanner';
import { LOCAL_STORAGE_KEYS, ROUTE_URL, RESIZE } from 'common/constants/SharedConstants';
import START_ORDER_CONSTANTS from 'organisms/StartOrderComponent/Constants/startOrderConstants';
import { PROMOS_AND_REWARDS_CONSTANT } from 'organisms/PromosRewards/Constants/PromosRewardsConstant';
import ViewDetailsModal from 'organisms/PromosRewards/Presentation/ViewDetailsModal';
import MultiProductPromoModal from 'organisms/PromosRewards/Container/MultiProductPromoModal';
import LtoBannerComponent from 'organisms/LtoBanner/Presentation/LtoBannerComponent';
import HOME_PAGE_CONTAINER_CONSTANTS from 'components/homePageContainer/Constants/AU/homePageContainerConstants';
import { getContentCall } from '@kfc-global/react-shared/redux/Actions/ContentAction';
import { getCmsClient } from 'common/utilities/cmsClient';
import { ChannelManager } from 'common/manager';
import ImageComponent from 'atoms/Image';
import { OF, LOAD_MORE } from 'organisms/DealsAndOffersLanding/constants/offersAndDealsConstants';
import AuthManager from '@kfc-global/react-shared/auth/AuthManager';
import { setRedeemOffersAndPromotionsAnalyticsData } from 'organisms/OffersAndPromotions/OffersAndPromotionsUtilities/offersAndPromotionsUtils';
import { CART_PAGE_CONSTANTS } from 'organisms/CartPage/Constants/CartPageConstants';
const { ANALYTICS_EVENTS } = CART_PAGE_CONSTANTS;

const { DEFAULT_PAGE_SIZE } = PROMOS_AND_REWARDS_CONSTANT;

const { LTO_BANNER } = HOME_PAGE_CONTAINER_CONSTANTS;
const updatePageCount = (localized, pageCount) => {
  return localized ? pageCount : 0;
};
const callGetCouponAPI = (getCoupons, dispositionNew, basketData) => {
  if (dispositionNew?.basketId !== basketData?.id) {
    getCoupons();
  }
};
const PromosRewardsLandingPage = props => {
  const {
    GUEST_USER_SINGIN_TEXT,
    THATS_ALL_FOR_NOW,
    CHECK_BACK_AGAIN,
    PROMOS_AND_REWARDS,
    FOR_MEMBERS_ONLY,
    KFC_SIGN_IN_EXCLUSIVE_PROMOS,
    CANCEL,
    YES_REMOVE,
    VIEWING,
    PROMO_REMOVE_CONFIRMATION,
    PROMO_SUCCESS_TOAST_MESSAGE,
    PROMO_REMOVE_TOAST_MESSAGE,
  } = TRANSLATE_MAPPING_KEY;
  const { StripesIcon, SignInCard, offer_deals_banner, tickWhiteToast } = IMAGE_PATH;
  const userParams = useSelector(state => state?.appStateReducer?.userStatus);
  const { loggedIn, localized } = getValueOrDefaultObject(userParams);
  const [offersContentData, setOffersContent] = useState([]);
  const [currPage, setPage] = useState(DEFAULT_PAGE_SIZE);
  const [orders, setOrders] = useState([]);
  const [showModal, setModal] = useState(false);
  const [showConfirmationModel, setConfirmationModel] = useState(false);
  const [viewProductCardData, setProductCardData] = useState({});
  const [viewProductEvent, setProductviewProductEvent] = useState(null);
  const [viewDetailsData, setViewDetailsData] = useState({});
  const [showMultiProductModal, setMultiProductModal] = useState(false);
  const [promosApplied, setPromosApplied] = useState(false);
  const [promosState, setPromosState] = useState('null');
  const { DISPOSITION_DATA, MENU_URL } = START_ORDER_CONSTANTS;
  const tenantData = useSelector(data => data?.tenantReducer);
  const { tenantId = '', componentOptions } = tenantData;
  const sendViewAllDealsEvent = getValueOrEmptyString(componentOptions?.web?.coupons?.sendViewAllDealsEvent);
  const cartReducer = useSelector(data => data?.cartReducer);
  const { applicableCoupons = [], cartData: basketData = {} } = cartReducer;
  const { discountLines = [] } = getValueOrDefaultObject(basketData);
  const { userOrderState, userOrderStateDispatch } = useContext(UserOrderContext);
  const dispatch = useDispatch();
  const dispositionNew = getDispositionNewData(userOrderState);
  const params = useMemo(() => {
    return {
      dispositionType: dispositionNew?.type
        ? getDispositionTypeOnAPIFormat(dispositionNew.type)
        : getDispositionTypeOnAPIFormat(tenantData?.authoredContent?.defaultdisposition),
    };
  }, [dispositionNew, tenantData]);
  const { dispositionType } = params;
  const getPageCount = (pageLimit, content = []) => Math.ceil(content.length / pageLimit);
  const { TimerRibbonRedOutlined, TimerIcon } = IMAGE_PATH;
  const [visibleCards, setVisibleCards] = useState(0);
  const [alertPopupCouponCode, setAlertPopupCouponCode] = useState('');
  const [pageCount, setPageCount] = useState(0);
  let segmentedHomePageData = null;
  let couponsInStorage = {};
  const [imageContainerSize, setImageContainerSize] = useState(0);
  const allContentData = useSelector(data => {
    return {
      homePageContent: get(data, 'contentReducer.response', null),
    };
  });
  const getCouponLoading = useSelector(data => data.cartReducer?.getCouponLoading);
  const [isApplicableAPILoading, setApplicableAPILoading] = useState(true);
  const handleClose = () => {
    setModal(false);
  };
  const handleAlertClose = () => {
    setConfirmationModel(false);
  };
  const handleMultiProductClose = () => {
    setMultiProductModal(false);
  };

  const setMultiProductModalHandler = (productData, event) => {
    setProductCardData({
      item: productData?.item,
      titleValue: productData?.titleValue,
      promoParams: productData?.promoParameters,
      priceDetails: productData?.priceDetails,
    });
    setProductviewProductEvent(event);
    setMultiProductModal(true);
  };

  const setViewDetailsHandler = productData => {
    setViewDetailsData({ item: productData?.item });
    setModal(true);
  };

  const setGreenTickHandler = productData => {
    const couponCode = productData?.couponCode || '';
    setConfirmationModel(true);
    setAlertPopupCouponCode(couponCode);
  };

  useLayoutEffect(() => {
    const calculateMarginWidth = () => {
      return isMobileDevice(window.innerWidth) ? [250.0 + 37, 20.0] : [310.0 + 37, window.innerWidth * 0.1];
    };
    const calculateVisibleItems = () => {
      const [cardWidth, leftMargin] = calculateMarginWidth();
      const contentWidth = window.innerWidth - leftMargin;
      let visibleItems = Math.ceil(contentWidth / cardWidth);

      if (visibleItems === 1) {
        visibleItems += 1;
      }
      return visibleItems;
    };

    const handleResize = () => {
      setVisibleCards(calculateVisibleItems());
      setImageContainerSize(window.innerWidth);
    };

    window.addEventListener(RESIZE, handleResize);
    handleResize();
    return () => window.removeEventListener(RESIZE, handleResize);
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (applicableCoupons.length > 0) {
      const data = getFinalContentData(loggedIn, modifyOffersData(applicableCoupons,tenantData));
      setIsAppliedInApplicableCoupon(data, promosState);
      setPageCount(getPageCount(1, offersContentData));
    } else {
      if (!offersContentData.length) {
        const data = getFinalContentData(loggedIn, [], getCouponLoading);
        setOffersContent(data);
      }
      setApplicableAPILoading(
        getTernaryValue(getAndCheckIfOneTrue(offersContentData.length, applicableCoupons.length), false, true),
      );
      setPageCount(0);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [applicableCoupons]);

  useEffect(() => {
    setOrders([...offersContentData].splice(0, currPage));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [offersContentData, currPage]);

  useEffect(() => {
    if (localized && tenantId) {
      callGetCouponAPI(getCoupons, dispositionNew, basketData);
    }
    setPageCount(updatePageCount(localized, pageCount));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    localized,
    loggedIn,
    basketData?.id,
    basketData?.customer?.id,
    tenantId,
    dispositionNew?.store?.id,
    dispositionNew?.type,
  ]);

  useEffect(() => {
    //get ApplicableCoupon api calling on coupon activation and removal
    if (promosState !== 'null') {
      getCoupons();
      // updating localStorage
      //setIsAppliedInApplicableCoupon(offersContentData, promosState);

      let toastTxt = promosState
        ? translateWithI18Next(PROMO_SUCCESS_TOAST_MESSAGE)
        : translateWithI18Next(PROMO_REMOVE_TOAST_MESSAGE);
      showToast(toastTxt);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [discountLines]);

  const setIsAppliedInApplicableCoupon = (data, appliedFlag) => {
    /** updating local storage */
    if (localStorage.getItem(LOCAL_STORAGE_KEYS.ADD_TO_ORDER)) {
      couponsInStorage = JSON?.parse(localStorage?.getItem(LOCAL_STORAGE_KEYS.ADD_TO_ORDER));
    }
    if (alertPopupCouponCode) {
      if (appliedFlag) {
        couponsInStorage[alertPopupCouponCode] = alertPopupCouponCode;
      } else if (couponsInStorage[alertPopupCouponCode]) {
        delete couponsInStorage[alertPopupCouponCode];
      }
      if (Object.keys(couponsInStorage).length > 0) {
        localStorage.setItem(LOCAL_STORAGE_KEYS.ADD_TO_ORDER, JSON.stringify(couponsInStorage));
      } else {
        localStorage.removeItem(LOCAL_STORAGE_KEYS.ADD_TO_ORDER);
      }
    }
    /** updating isApplied key in applicable coupon response */
    for (let promos in couponsInStorage) {
      let couponCode = couponsInStorage[promos];
      data = data.map(obj => (obj.couponCode === couponCode ? { ...obj, isApplied: appliedFlag } : obj));
    }
    /** updating state */
    setOffersContent(data);
    const checkPromoAppled = data.some(item => item.isApplied && !item.employeePromotion);
    setPromosApplied(checkPromoAppled);
    setApplicableAPILoading(
      getTernaryValue(getAndCheckIfOneTrue(offersContentData.length, applicableCoupons.length), false, true),
    );
  };

  const showToast = toastTxt => {
    let imageTemplate = <ImageComponent srcFile={tickWhiteToast} />;
    toastifyFnWithImage(toastTxt, imageTemplate, 'promos-rewards-toast');
  };

  useEffect(() => {
    dispatch(
      getContentCall({
        object: getCmsClient(),
        contentFull: {
          content_type: 'landingPage',
          'fields.channel': ChannelManager.channel,
          include: '5',
        },
        userParams: {
          loggedIn: true,
          localized,
        },
      }),
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, userOrderState]);

  if (allContentData?.homePageContent) {
    segmentedHomePageData = getValueOrnull(getHeaderContentData(allContentData?.homePageContent));
  }

  const LTOBannerContainer =
    (isEmptyObject(segmentedHomePageData) && segmentedHomePageData[LTO_BANNER] && (
      <LtoBannerComponent
        contentData={getValueOrDefaultObject(segmentedHomePageData[LTO_BANNER])}
        history={props.history}
      />
    )) ||
    null;

  const getCoupons = () => {
    const { customerId } = AuthManager.getInstance();
    if (localized && basketData?.id && customerId === basketData?.customer?.id) {
      dispatch(
        getApplicableCouponsAction({
          basketId: basketData?.id,
          tenantId,
        }),
      );
    }
  };

  const setLocationClickHandler = () => {
    dispatch(resetStores());
    userOrderStateDispatch({ type: DISPOSITION_DATA, value: { showDisposition: true } });
    localStorage.setItem(LOCAL_STORAGE_KEYS.RETAIN_ADDRESS, '');
    localStorage.setItem(LOCAL_STORAGE_KEYS.SET_LOCATION, true);
  };

  /* show ribbon component  */
  const getRibbon = data => {
    if (data?.showTimer && isTimeValid(data?.validityEndTime)) {
      const header = (
        <span data-testid='promos-time-block' className='promos-time-block'>
          <img className='promos-time-icon' src={TimerIcon} alt='Timer Icon' />
          <TimerView endTime={data?.validityEndTime} />
        </span>
      );
      return (
        <div className='promosRibbon-container'>
          <ReactSVG src={TimerRibbonRedOutlined} className='promos-ribbon timer' />
          <span className='ribbon-text time-text'>{header}</span>
        </div>
      );
    } else if (data?.header) {
      const header = data?.header;
      return (
        <div className='promosRibbon-container'>
          <div className='angle-down'></div>
          <span className='ribbon-text-svg'>{truncate(header)}</span>
        </div>
      );
    }
  };

  const signInCard = (index, currentSlide, visibleCardsData) => {
    return (
      <div
        className={`slick-slide medium-card-offers-deals store-card ${
          index === currentSlide + visibleCardsData - 1 && 'offersCard-fade lastOffersCard-fade'
        }`}
      >
        <img src={SignInCard} className='offers-store-image' alt='' />
        <h3 className='offer-login-text'>{translateWithI18Next(KFC_SIGN_IN_EXCLUSIVE_PROMOS)}</h3>
        <div className='offer-store-btn-container'>
          <ButtonComp data-testid='sign-in-btnid' onClick={() => login()} className='store-btn signin-offers-btn'>
            {translateWithI18Next(GUEST_USER_SINGIN_TEXT)}
          </ButtonComp>
        </div>
      </div>
    );
  };

  const nilCard = () => {
    return (
      <div className='nilCard-main-container'>
        <div class='thats-all-text'>{translateWithI18Next(THATS_ALL_FOR_NOW)}</div>
        <div class='back-again-text'>{translateWithI18Next(CHECK_BACK_AGAIN)}</div>
      </div>
    );
  };

  const promosCarousel = promosData => {
    return promosData?.map((item, index) => {
      const { couponCode, smallText, titleValue, imageName, validityEndTime, promoParameters, itemDetails } =
        getValueOrDefaultObject(item);
      const priceDetails = itemDetails?.map(it => ({
        id: it?.id,
        availability: it?.availability,
      }));
      return (
        <div key={index} className='promos-reward-cards-container'>
          {
            <div className='promos-reward-card-container'>
              {getRibbon(item)}
              <PromosRewardsCard
                data-testid='promos-rewards-card'
                loggedIn={loggedIn}
                localized={localized}
                couponCode={couponCode}
                smallText={smallText}
                titleValue={titleValue}
                imageName={imageName}
                item={item}
                promoParameters={promoParameters}
                priceDetails={priceDetails}
                validityEndTime={validityEndTime}
                tenantId={tenantId}
                setModal={setModal}
                setViewDetailsHandler={setViewDetailsHandler}
                setConfirmationModal={setGreenTickHandler}
                showMultiProductModal={setMultiProductModalHandler}
                dispositionType={dispositionType}
                addToOrderClickHandler={onAddToOrderClick}
                startOrderClickHandler={onStartOrderClick}
                promosApplied={promosApplied}
                basketData={basketData}
                setViewCartHandler={setViewCartHandler}
                setDispositionHandler={setDispositionHandler}
                setAlertPopupCouponCode={setAlertPopupCouponCode} //added only for test case
                setIsAppliedInApplicableCoupon={setIsAppliedInApplicableCoupon} // added only for test case
                createSignInURL={login}
              />
            </div>
          }
        </div>
      );
    });
  };
  const promosCardNilState = () => {
    return (
      <div className='nil-card-container'>
        {nilCard()}
        {!loggedIn && signInCard()}
      </div>
    );
  };
  const onAddToOrderClick = (productData, event) => {
    const couponCode = productData?.couponCode;
    dispatch(
      applyCoupon(
        {
          basketId: basketData?.id,
          tenantId,
        },
        {
          couponCode: couponCode,
        },
      ),
    );
    setPromosState(true);
    setAlertPopupCouponCode(couponCode);
    setIsAppliedInApplicableCoupon(offersContentData, promosState);
  };

  const onStartOrderClick = (productData, event) => {
    const couponCode = productData?.couponCode;
    props.history.push({
      pathname: getTernaryValue(isCateringDisposition(dispositionType), ROUTE_URL?.CATERING_PAGE, `${MENU_URL}`),
      isStartOrderClick: true
    });
    if (sendViewAllDealsEvent) {
      setRedeemOffersAndPromotionsAnalyticsData({
        event: ANALYTICS_EVENTS.REDEEM_OFFER,
        offerTitle: couponCode,
      });
    }
  };
  const removeAppliedCoupon = (productData, event) => {
    if (alertPopupCouponCode) {
      dispatch(
        removeCouponAction({
          basketId: basketData?.id,
          tenantId,
          couponCode: alertPopupCouponCode,
        }),
      );
      handleAlertClose();
      setPromosState(false);
    }
  };

  const setViewCartHandler = productData => {
    const couponCode = productData?.couponCode;
    props.history.push({
      pathname: ROUTE_URL.CART,
    });
    if (sendViewAllDealsEvent) {
      setRedeemOffersAndPromotionsAnalyticsData({
        event: ANALYTICS_EVENTS.REDEEM_OFFER,
        offerTitle: couponCode,
      });
    }
  };
  const setDispositionHandler = selectedDispositionType => {
    userOrderStateDispatch({ type: DISPOSITION_DATA, value: { showDisposition: true } });
  };

  return (
    <div
      id='promosRewards'
      className='promos-container promos-landingPage-container'
      data-testid='promos-container-test'
    >
      <div
        style={{
          backgroundImage: `url(${offer_deals_banner})`,
        }}
        className='deals-header-image'
      >
        <h2 className='deals-image-text'>{translateWithI18Next(PROMOS_AND_REWARDS)}</h2>
      </div>
      <div className='promosCard-container grid-container' data-testid='promosCard-container-test'>
        <div className='promos-Icon'>
          <ReactSVG src={StripesIcon} />
        </div>
        <div className='promosContainerHeader-items'>
          <h2 className='promosContainer-header'>{translateWithI18Next(PROMOS_AND_REWARDS)}</h2>
          {localized && !loggedIn && <div className='promosHeader-text'>{translateWithI18Next(FOR_MEMBERS_ONLY)}</div>}
          {getAndCheck(localized, !loggedIn) && (
            <div className='view-all-text'>
              <a
                className='offersViewAll-link promosHeader-right-text'
                onClick={() => login()}
                data-testid='view-all-deals-handler'
              >
                {translateWithI18Next(KFC_SIGN_IN_EXCLUSIVE_PROMOS)}
              </a>
            </div>
          )}
        </div>
        {localized && (
          <>
            {isApplicableAPILoading && (
              <div className='placeholder'>
                {Array(3)
                  .fill()
                  .map(() => (
                    <div className='table store-card-container'>
                      <div className='loading card-title shorter-s' />
                      <div className='loading table-content' />
                      <div className='loading table-content' />
                    </div>
                  ))}
              </div>
            )}
            {getAndCheck(offersContentData.length, !isApplicableAPILoading) && (
              <div className='promos-reward-page-container'>
                {promosCarousel(orders?.length ? orders : offersContentData)}
              </div>
            )}
          </>
        )}
        {localized && !offersContentData?.length && (
          <>
            <div className='promos-reward-nil-container'>{promosCardNilState()}</div>
          </>
        )}

        {currPage < offersContentData?.length && pageCount > 1 && (
          <div className='promos-load-more-footer'>
            <div className='load-more-container'>
              <ButtonComp
                data-testid='load-more-btn'
                className='button whiteButton blackBorder load-btn'
                onClick={() => setPage(currPage + DEFAULT_PAGE_SIZE)}
              >
                {translateWithI18Next(LOAD_MORE)}
              </ButtonComp>
              <span className='page-desc'>
                {`${translateWithI18Next(VIEWING)} ${currPage} ${translateWithI18Next(OF)} ${
                  offersContentData?.length
                }`}
              </span>
            </div>
          </div>
        )}
      </div>
      {!localized && <PromosBanner data-testid='promos-banner-id' setLocationClickHandler={setLocationClickHandler} />}
      {<div className='lto-banner-promos-rewards-page'>{LTOBannerContainer}</div>}
      {showModal && (
        <ViewDetailsModal
          history={props.history}
          data-testid='view-details-modalId'
          tenantId={tenantId}
          viewDetailsData={viewDetailsData}
          handleClose={handleClose}
        />
      )}
      {showMultiProductModal && (
        <MultiProductPromoModal
          data-testid='multi-product-modalId'
          viewProductEvent={viewProductEvent}
          history={props.history}
          tenantId={tenantId}
          viewProductCardData={viewProductCardData}
          handleClose={handleMultiProductClose}
          imageContainerSize={imageContainerSize}
        />
      )}

      {showConfirmationModel && (
        <AlertFormInsideModel
          data-testid='remove-promo-modal'
          handleClose={handleAlertClose}
          classNames='promos-rewards-warning-msg'
          CartAlertForm={
            <AlertForm
              splitTitle={{ MSGTXT1: `${translateWithI18Next(PROMO_REMOVE_CONFIRMATION)}` }}
              imageSrc={IMAGE_PATH.CartError}
              confirmButtonText={translateWithI18Next(YES_REMOVE)}
              cancelButtonText={translateWithI18Next(CANCEL)}
              confirmHandler={removeAppliedCoupon}
              cancelHandler={handleAlertClose}
              buttonContainerClass='deeplink-alert-btn-container alert-btn-container'
              data-testid='alert-form-modalId'
            />
          }
        />
      )}
    </div>
  );
};

export default PromosRewardsLandingPage;
